import {
  Box, Grid, Paper, Select, Typography,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button,
} from "@mui/material";
import React from "react";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import {FileUpload as FileUploadIcon} from "@mui/icons-material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

interface ServerErrorCheckingProps {
  isLoading: boolean;
  serverError: any[];
}

const classes = {
  iconSuccess: {
    color: "#0FBF00",
    marginBottom: 2,
  }
};

const ServerErrorChecking = (props: ServerErrorCheckingProps) => {
  const { isLoading, serverError } = props;
  // handle show result

  const renderError = (errors) => {
    let message = ``
    if (errors) {
      Object.keys(errors).map((key) => {
        message += errors[key].message + '\n';
      })
    }
    return message;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      width="100%"
      padding={4}
    >
      {isLoading ? (
        <Box width="100%" textAlign="center">
          <ProgressIndicator />
          <Typography>
            Checking data...
            <br />
            Please wait a moment
          </Typography>
        </Box>
      ) : serverError.length > 0 ? (
        <TableContainer sx={{ maxHeight: 420, width: 1 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Row #</TableCell>
                <TableCell>Terminal Error</TableCell>
                <TableCell>Merchant Error</TableCell>
                <TableCell>POS Error</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(serverError) && serverError.length && serverError.map((row) => (
                <TableRow
                  key={row.rowIndex}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">{row.rowIndex + 1}</TableCell>
                  <TableCell style={{ whiteSpace: 'pre' }}>
                    {row?.terminalError ? renderError(row.terminalError) : ''}
                  </TableCell>
                  <TableCell style={{ whiteSpace: 'pre' }}>
                    {row?.merchantError ? renderError(row.merchantError) : ''}
                  </TableCell>
                  <TableCell style={{ whiteSpace: 'pre' }}>
                    {row?.posError ? renderError(row.posError) : ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          width="100%"
          padding={4}
        >
          <CheckCircleOutlineIcon fontSize="large" sx={classes.iconSuccess} />
          <Typography align="center">
            All of the rows has valid Data.
            <br/>
            Please click Import Data to Process.
          </Typography>
          <br/>
        </Box>
      )}
    </Box>
  );
};

export default ServerErrorChecking;
